'use client';

import { useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import { CustomSpin } from '@modules/shared/components/CustomSpin';
import { usePostLoginMembershipRedirect } from 'app/_utils/auth/use-post-login-membership-redirect';

import React from 'react';

/**
 * `/` lives under `(authenticated)` so AuthGuard + app providers run before this mounts.
 * In production, unauthenticated users never reach this component (AuthGuard handles login from `/`).
 * Signed-in users are routed with the same membership-based rules as `/callback` (including the
 * single-org shortcut when they have no system cloud roles). Zeus `POST /v2/system/post-login` runs on
 * `/callback` only — not here — so repeat visits to `/` do not re-sync authorizations unnecessarily.
 */
const HomePage: React.FC = () => {
  const { user } = useCommonAuthProvider();

  usePostLoginMembershipRedirect({
    enabled: Boolean(user),
  });

  return <CustomSpin />;
};

export default HomePage;
